import { Stacked } from '@statsbomb/kitbag-components';
import { ColouredArrowMarkers, ColouredMarkers } from '@statsbomb/kitbag-datavis';
import { useTranslation } from 'react-i18next';
import { DEFAULT_MARKER_SHAPE } from '@/consts/visualisations';
import { useSuccessFailColouring } from '@/hooks/useSuccessFailColouring';

export const EventMapArrowMarkerLegend = ({ withMarkers = false }: { withMarkers?: boolean }) => {
  const { t } = useTranslation('visualisation');
  const successFailColouring = useSuccessFailColouring();
  const markerShape = withMarkers ? DEFAULT_MARKER_SHAPE : undefined;

  return (
    <Stacked direction="column">
      <ColouredArrowMarkers
        title={t('markerColouring.outcome')}
        arrowMarkers={[
          {
            label: t('outcomeLegend.success'),
            strokeColour: successFailColouring.success,
            arrowHead: 'EQUILATERAL',
            markerShape,
          },
          {
            label: t('outcomeLegend.fail'),
            strokeColour: successFailColouring.fail,
            arrowHead: 'EQUILATERAL',
            markerShape,
          },
        ]}
      />
      <ColouredMarkers
        title=""
        markers={[
          {
            label: t('outcomeLegend.neutral'),
            colour: successFailColouring.neutral,
          },
        ]}
      />
    </Stacked>
  );
};
